<template>
  <div id="footer">
    <div class="hg-page-width content">
      <div class="logo">
        <img src="@/assets/img/brand-yidao.jpg" alt="logo图" />
        <p class="title">益稻粮品</p>
      </div>
      <span class="address">中国福建省泉州市鲤城区九一街益华商业大厦905</span>
      <span class="address">hugou@email.com</span>
      <div class="hg-line-bg"></div>
      <p class="copy">
        Copyright &copy; @2020 互勾版权所有 | 互勾商城隐私政策 |
        互勾商城用户协议 |
        <a href="https://beian.miit.gov.cn" target="_blank"
          >闽ICP备2020020027号</a
        >
      </p>
      <span class="rlb">服务热线</span>
      <span class="rlb">周一至周日 9:00-18:00</span>
      <span class="rlb">400-1027-517</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/css/common.css";
#footer {
  text-align: left;
  position: relative;
  bottom: 0;
  height: 200px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  background: rgba(244, 244, 244, 1);
}
.content {
  display: grid;
  grid-template-columns: 60% 40%;
  grid-template-rows: repeat(9, 1fr);
  grid-row-gap: 10px;
  grid-auto-flow: column;
  justify-items: start;
  padding: 16px 0px;
}
.hg-line-bg {
  height: 1px;
  background: rgba(216, 216, 216, 1);
  grid-row-start: 6;
  grid-row-end: 9;
  grid-column-start: 1;
  grid-column-end: 3;
  justify-self: stretch;
  align-self: end;
}
.logo {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  grid-row-start: 1;
  grid-row-end: 4;
  justify-content: space-around;
  img {
    width: 60px;
    height: 60px;
  }
  .title {
    font-size: 18px;
    font-weight: 400;
    color: rgba(35, 35, 40, 1);
    line-height: 18px;
    margin-left: 8px;
    text-align: center;
    align-self: center;
  }
}
.rlb {
  font-size: 14px;
  font-weight: 400;
  color: rgba(35, 35, 40, 0.5);
  line-height: 14px;
  // justify-self: end;
}
.address {
  font-size: 14px;
  font-weight: 400;
  color: rgba(35, 35, 40, 0.5);
  line-height: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  grid-row-start: 9;
  grid-row-end: 10;
  grid-column-start: 1;
  grid-column-end: 3;
  justify-self: center;
}
@media screen and (max-width: 997px) {
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue